/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

var moment = require('moment');
window.Vue = require('vue');

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

require('./components/bootstrap');
require('./filters');

import { BootstrapVue, BootstrapVueIcons} from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);

import Permissions from './mixins/Permissions'
Vue.mixin(Permissions);

import AirbnbStyleDatepicker from 'vue-airbnb-style-datepicker'
import 'vue-airbnb-style-datepicker/dist/vue-airbnb-style-datepicker.min.css'

import Datetime from 'vuejs-datetimepicker'
Vue.use(Datetime)
Vue.component('date-time', require('vuejs-datetimepicker').default);

// see docs for available options
const datepickerOptions = {
    sundayFirst: true,
    dateLabelFormat: 'YYYY-MM-DD',
    days: ['月曜日', '火曜日', '水曜日', '木曜日', '金曜日', '土曜日', '日曜日'],
    daysShort: ['月', '火', '水', '木', '金', '土', '日'],
    monthNames: [
        '1月',
        '2月',
        '3月',
        '4月',
        '5月',
        '6月',
        '7月',
        '8月',
        '9月',
        '10月',
        '11月',
        '12月',
    ],
    colors: {
        selected: '#00a699',
        inRange: '#66e2da',
        selectedText: '#fff',
        text: '#565a5c',
        inRangeBorder: '#33dacd',
        disabled: '#fff',
    },
    texts: {
        apply: 'OK',
        cancel: 'キャンセル',
        keyboardShortcuts: 'Keyboard Shortcuts',
    },
    // ariaLabels: {
    //     chooseDate: (date) => date,
    //     chooseStartDate: (date) => `Choose ${date} as your start date.`,
    //     chooseEndDate: (date) => `Choose ${date} as your end date.`,
    //     selectedDate: (date) => `Selected. ${date}`,
    //     unavailableDate: (date) => `Not available. ${date}`,
    //     previousMonth: 'Move backward to switch to the previous month.',
    //     nextMonth: 'Move forward to switch to the next month.',
    //     closeDatepicker: 'Close calendar',
    //     openKeyboardShortcutsMenu: 'Open keyboard shortcuts menu.',
    //     closeKeyboardShortcutsMenu: 'Close keyboard shortcuts menu'
    // },
    keyboardShortcuts: [
        { symbol: '↵', label: 'Select the date in focus', symbolDescription: 'Enter key' },
        { symbol: '←/→', label: 'Move backward (left) and forward (down) by one day.', symbolDescription: 'Left or right arrow keys' },
        { symbol: '↑/↓', label: 'Move backward (up) and forward (down) by one week.', symbolDescription: 'Up or down arrow keys' },
        { symbol: 'PgUp/PgDn', label: 'Switch months.', symbolDescription: 'PageUp and PageDown keys' },
        { symbol: 'Home/End', label: 'Go to the first or last day of a week.', symbolDescription: 'Home or End keys' },
        { symbol: 'Esc', label: 'Close this panel', symbolDescription: 'Escape key' },
        { symbol: '?', label: 'Open this panel', symbolDescription: 'Question mark' }
    ],
}

// make sure we can use it in our components
Vue.use(
    AirbnbStyleDatepicker, 
    datepickerOptions
)

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = new Vue({
    el: '#app',
    data: {},
    methods: {
        test: function () {
            console.log('it works')
        }
    },
    created: function() {
        this.test()
    }
});
